// utils.js — shared helpers for V4 modules
// These are V4-native; app-legacy.js has its own equivalent `api()` function.

export async function apiFetch(path, options = {}) {
  const res = await fetch(path, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text.startsWith('<') ? `Server error (${res.status})` : text);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatCurrency(amount) {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

// Manual action dispatcher — shared across all views.
// Fires POST /api/manual-actions/run and updates an optional inline status element.
// statusElId: the DOM id of a <span> to show progress/result (pass null to skip).
export async function runManualAction(actionKey, ctx = {}, statusElId = null) {
  const statusEl = statusElId ? document.getElementById(statusElId) : null;
  if (statusEl) { statusEl.textContent = 'Running…'; statusEl.className = 'auto-inline-hint auto-hint-cyan'; }
  try {
    const r = await apiFetch('/api/manual-actions/run', {
      method: 'POST',
      body: JSON.stringify({ action: actionKey, ...ctx }),
    });
    if (statusEl) {
      statusEl.textContent = `✓ ${new Date().toLocaleTimeString()}`;
      statusEl.className = 'auto-inline-hint auto-hint-green';
    }
    return r;
  } catch (err) {
    if (statusEl) {
      statusEl.textContent = `✗ ${err.message}`;
      statusEl.className = 'auto-inline-hint auto-hint-red';
    }
    throw err;
  }
}
